<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toc"><a href="#/xhtml/05_Acknowledgements"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="toc"><a href="#/xhtml/06_Introduction"><em class="italic">Introduction</em></a></h2>
<h2 class="tocc"><a href="#/xhtml/07_Chapter01"><span class="tocc"><span class="bold">Chapter 1</span></span> Nazis in Britain 1930–1939</a></h2>
<h2 class="tocc"><a href="#/xhtml/08_Chapter02"><span class="tocc"><span class="bold">Chapter 2</span></span> Victims of Nazi Vengeance</a></h2>
<h2 class="tocc"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 3</span></span> Sympathisers and ‘Spyclists’</span></h2>
<h2 class="tocc"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 4</span></span> Spies Among Us</span></h2>
<h2 class="tocc"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 5</span></span> Fatalities of Spy Mania?</span></h2>
<h2 class="tocc"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 6</span></span> The Venlo Incident</span></h2>
<h2 class="tocc"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 7</span></span> Operation Lena</span></h2>
<h2 class="tocc"><span href="#/xhtml/15_Chapter08" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 8</span></span> The Undetected?</span></h2>
<h2 class="tocc"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 9</span></span> The Fifth Column</span></h2>
<h2 class="tocc"><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 10</span></span> The British Black List</span></h2>
<h2 class="tocc"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 11</span></span> In the Event of Invasion</span></h2>
<h2 class="tocc"><span href="#/xhtml/20_Chapter12" title="Link target outside of Sample"><span class="tocc"><span class="bold">Chapter 12</span></span> The Invasion That Never Was</span></h2>
<h2 class="toc2"><span href="#/xhtml/21_Appendix01" title="Link target outside of Sample"><em class="italic">Appendix I: Civil Defence Regions, Commissioners, Headquarters and Regional Security Liaison Officers, December 1940</em></span></h2>
<h2 class="toc"><span href="#/xhtml/22_Appendix02" title="Link target outside of Sample"><em class="italic">Appendix II: Maxwell Knight’s Account of ‘The Wolkoff – Kent Case’</em></span></h2>
<h2 class="toc"><span href="#/xhtml/23_Appendix03" title="Link target outside of Sample"><em class="italic">Appendix III: Victor Rothschild on Sabotage</em></span></h2>
<h2 class="toc"><span href="#/xhtml/24_Notes" title="Link target outside of Sample"><em class="italic">Notes</em></span></h2>
<h2 class="toc"><span href="#/xhtml/25_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?06f0c72d